import React from 'react'
import moment from 'moment'

export default function useTranslatedShortLastMonth () {
  return moment().subtract(1, 'month').format('MMM')
}
